import { useQuery } from "@tanstack/react-query";

import { getCart } from "../../api/cart";
import type { Cart } from "../../api/cart";

/** cartQueryKey — общий ключ кэша корзины: им же обновляют кэш мутации корзины. */
export const cartQueryKey = ["cart"] as const;

/** useCart — корзина покупателя (docs/07-miniapp-ux.md §2.4). */
export function useCart() {
  return useQuery({
    queryKey: cartQueryKey,
    queryFn: ({ signal }) => getCart(signal),
    staleTime: 30_000,
  });
}

/** cartQtyOf — количество товара в уже загруженной корзине; 0, если корзины ещё нет или товара в ней нет. */
export function cartQtyOf(cart: Cart | undefined, productId: string): number {
  return cart?.items.find((item) => item.product_id === productId)?.qty ?? 0;
}
